import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

/**
 * Pass in either current and max or percent (as a value out of 100).
 */
export default function ProgressBar({
    className,
    children,
    current, // Current value
    innerOnly, // Don't show the gray background for "incomplete" part of bar
    max, // Max value
    metric, // Metric value line to display
    percent, // Current percent
    gradient, // Gradient style for the bar
    contentAtEnd, // Show text/content of progress bar after the bar rather than inside it
}) {
    let widthPerc = percent;
    if (current && max) {
        widthPerc = Math.round((current / max) * 100);
    }

    const width = `${widthPerc}%`;
    const outerStyle = {};
    const innerStyle = {};
    const contentStyle = {};
    if (innerOnly) {
        outerStyle.width = width;
    } else {
        innerStyle.width = width;
    }
    if (gradient) {
        innerStyle.backgroundImage = gradient;
    }
    if (contentAtEnd) {
        contentStyle.paddingLeft = `calc(${widthPerc}% + 8px)`;
    }

    const classes = classNames(
        "progress-bar",
        {
            "progress-zero": widthPerc === 0,
        },
        className,
    );

    return (
        <div className={classes} style={outerStyle}>
            <div className="progress-bar__inner" style={innerStyle} />
            {children && (
                <div
                    className={classNames("progress-bar__content", {
                        "progress-bar__content--at-end": contentAtEnd,
                    })}
                    style={contentStyle}
                >
                    {children}
                </div>
            )}
            {metric && <div className="progress-bar__metric" style={{ left: `${metric}%` }} />}
        </div>
    );
}

ProgressBar.propTypes = {
    className: PropTypes.string,
    current: PropTypes.number,
    innerOnly: PropTypes.bool,
    max: PropTypes.number,
    metric: PropTypes.number,
    percent: PropTypes.number,
    gradient: PropTypes.string,
    contentAtEnd: PropTypes.bool,
};

ProgressBar.defaultProps = {
    className: null,
    current: 0,
    innerOnly: false,
    max: 0,
    metric: null,
    percent: 0,
    gradient: null,
    contentAtEnd: false,
};
